export default function Rust_DataTypes() {
  return (
    <div>
      <h1>Rust_DataTypes Component</h1>
      <p>This is the Rust_DataTypes page.</p>
    </div>
  );
}
